import { defineMessages } from 'react-intl';

const pageItems = defineMessages({
    title: {
        id: 'documents.pageItems.title',
        defaultMessage: 'Documents',
    },
    subtitle: {
        id: 'documents.pageItems.subtitle',
        defaultMessage: 'Please Review Below',
    },
    information: {
        id: 'documents.pageItems.information',
        defaultMessage: 'Must be reviewed by Primary Hirer.',
    },
    informationCa: {
        id: 'documents.pageItems.informationCa',
        defaultMessage: 'Must be reviewed by Lead Driver.',
    },
    reference: {
        id: 'documents.pageItems.reference',
        defaultMessage: 'RA#: {reference}',
    },
    endOfPage: {
        id: 'documents.pageItems.endOfPage',
        defaultMessage: 'End of page',
    },
});

const buttons = defineMessages({
    continue: {
        id: 'documents.buttons.continue',
        defaultMessage: 'Save & Continue',
    },
    review: {
        id: 'documents.buttons.review',
        defaultMessage: 'Review',
    },
    accepted: {
        id: 'documents.buttons.accepted',
        defaultMessage: 'Accepted',
    },
    accept: {
        id: 'documents.buttons.accept',
        defaultMessage: 'Accept',
    },
    declined: {
        id: 'documents.buttons.declined',
        defaultMessage: 'Refused',
    },
    decline: {
        id: 'documents.buttons.decline',
        defaultMessage: 'Refuse',
    },
    acceptDocument: {
        id: 'documents.buttons.acceptDocument',
        defaultMessage: 'I Agree to this document',
    },
});

const errors = defineMessages({
    required: {
        id: 'documents.errors.required',
        defaultMessage: 'Please review this document.',
    },
});

const documentsMessages = {
    pageItems,
    buttons,
    errors,
};

export default documentsMessages;
